import { http } from '../../../../api/http';
import type { OrdenPedido } from '../types/ordenPedido.types';

export class OrdenPedidoService {
  private static readonly ENDPOINTS = {
    BASE: '/ventas/orden-pedido',
  };

  public static async getAll(): Promise<OrdenPedido[]> {
    try {
      const response = await http.get(this.ENDPOINTS.BASE);
      return response.data;
    } catch (error) {
      console.error('Error fetching ordenes pedido:', error);
      throw error;
    }
  }

  public static async getById(id: number): Promise<OrdenPedido> {
    try {
      const response = await http.get(`${this.ENDPOINTS.BASE}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching orden pedido:', error);
      throw error;
    }
  }

  public static async save(data: OrdenPedido): Promise<OrdenPedido> {
    try {
      const response = await http.post(this.ENDPOINTS.BASE, data);
      return response.data;
    } catch (error) {
      console.error('Error saving orden pedido:', error);
      throw error;
    }
  }

  public static async update(id: number, data: OrdenPedido): Promise<OrdenPedido> {
    try {
      const response = await http.put(`${this.ENDPOINTS.BASE}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating orden pedido:', error);
      throw error;
    }
  }

  public static async delete(id: number): Promise<boolean> {
    try {
      await http.delete(`${this.ENDPOINTS.BASE}/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting orden pedido:', error);
      throw error;
    }
  }
}
